// Shared constants for the Dojo Sparks marketing pages (pricing / success / feature-support).
// Prices + Stripe links mirror the live external-site values.

export const STRIPE_MONTHLY_HREF = "https://buy.stripe.com/7sI6pce8f8oZ9BmcNe";
export const STRIPE_ANNUAL_HREF = "https://buy.stripe.com/cN29Bofcj20B8xi5kU";

export const SUPPORT_EMAIL = "hello@classdojo.com";

// App store listings
export const IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/classdojo/id552602056?ppid=1fbeb4a1-2c87-4470-a1da-e130d6e96e63";
export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.classdojo.android&listing=sparks";

// Universal links
export const SPARKS_PAYWALL_UNIVERSAL_LINK = "https://www.classdojo.com/ul/p/learning/sparks/paywall";
export const SPARKS_APP_UNIVERSAL_LINK = "/ul/s/sparks";
export const SPARKS_APP_UNIVERSAL_LINK_ABSOLUTE = "https://www.classdojo.com/ul/s/sparks";

type PlanCopy = {
  id: "monthly" | "annual";
  title: string;
  price: string;
  cadence: string;
  unitLabel: "month" | "year";
  href: string;
  badge?: string;
  strikethrough?: string;
  subtext?: string;
  wasPrice?: string;
  perMonthCompact?: string;
};

export const MONTHLY_PLAN: PlanCopy = {
  id: "monthly",
  title: "Monthly",
  price: "$9.99",
  cadence: "/ month",
  unitLabel: "month",
  href: STRIPE_MONTHLY_HREF,
};

export const ANNUAL_PLAN: PlanCopy = {
  id: "annual",
  title: "Annual",
  price: "$64.99",
  cadence: "/ year",
  unitLabel: "year",
  href: STRIPE_ANNUAL_HREF,
  badge: "SAVE 45%",
  strikethrough: "$119.88 / yr",
  subtext: "$5.42 / mo",
  wasPrice: "$119.88",
  perMonthCompact: "$5.42/MO",
};
